import gift from '../../Assets/Images/plp-banner-desktop.png'
const Features = () => {
    return (
        <>
            <div className="container py-5">
                <div className="row justify-content-between align-items-center">
                    <div className="col-12">
                        <h2 className='text-center fw-bold'>Feature and benefits</h2>
                    </div>

                    <div className="col-lg-5 pt-5">
                        <ul class="custom-list">
                            <li>Lorem ipsum dolor sit, amet consectetur adipisicing elit. </li>
                            <li>Sapiente quasi, ratione cupiditate ducimus quos omnis voluptatem quas qui ullam aliquid.</li>
                            <li>Veritatis impedit maiores error officiis, at reprehenderit tempora molestias itaque!</li>
                            <li>Lorem ipsum dolor sit, amet consectetur adipisicing elit. </li>
                            <li>Sapiente quasi, ratione cupiditate ducimus quos omnis voluptatem quas qui ullam aliquid.</li>
                            <li>Veritatis impedit maiores error officiis, at reprehenderit tempora molestias itaque!</li>

                        </ul>

                    </div>

                    <div className="col-lg-5 pt-5">
                        <img src={gift} width={"100%"} className='rounded-4' alt="" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Features